import { render, staticRenderFns } from "./ItsWaybillDetail.vue?vue&type=template&id=684fa3d6&scoped=true&"
import script from "./ItsWaybillDetail.vue?vue&type=script&lang=js&"
export * from "./ItsWaybillDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsWaybillDetail.vue?vue&type=style&index=0&id=684fa3d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fa3d6",
  null
  
)

export default component.exports